// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__ImszC","label":"LabeledBox_label___8dnH"};